// removed by extract-text-webpack-plugin
module.exports = {"Header":"src-components-Header----Header-module---Header---1_x3h","line1Container":"src-components-Header----Header-module---line1Container---1ik_C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.module.css
// module id = 380
// module chunks = 114276838955818